import React, { useState, useContext } from 'react';
import { Row, Col } from 'react-bootstrap'
import { authContext } from '../../../context/AuthContext';
import LoadingList from '../../../loader/LoadingList';
import ComponentModalErrorSever from '../../../components/ComponentModalErrorSever';
import DiagnosticoList from './DiagnosticoList';
import AddDiagnostico from './AddDiagnostico';

function DiagnosticosIndex(){

    //Parametros para actualizar la tabla
    const [itemToEdit, setItemToEdit] = useState(null)
    const [loading, setLoading] = useState(false)
    const [recheck, setRecheck] = useState(true)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)


    const getToEdit = (item) => {
        setItemToEdit(item)
    }

    return(<>
        {loading && <LoadingList texto='' />}

        <div className="body">
            
            <Row>
                <Col xs="12" md="5">
                    <AddDiagnostico 
                        auth={auth}
                        itemToEdit={itemToEdit}
                        setItemToEdit={setItemToEdit}
                        setShowModalError={setShowModalError}
                        setErrorServer={setErrorServer}
                        recheck={recheck}
                        setRecheck={setRecheck}
                    />
                </Col>
                <Col xs="12" md="7">
                    <DiagnosticoList 
                        setLoading={setLoading} 
                        auth={auth}
                        setShowModalError={setShowModalError}
                        setErrorServer={setErrorServer}
                        getToEdit={getToEdit}
                        recheck={recheck}
                    />
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
    </>)
}

export default DiagnosticosIndex